import {cn} from '../../lib/utils';
import {Icon} from '../Icon';
import {Typography} from '../Typography';

import type {FC, ReactNode} from 'react';

const SIZES = {
  xs: {icon: 16, iconBox: 'h-4', padding: 'px-3 py-2.5'},
  sm: {icon: 18, iconBox: 'h-5', padding: 'px-4 py-3'}
} as const;

export interface InfoNoticeProps {
  children: ReactNode;
  /** Match the surrounding copy: `xs` inside small cards, `sm` on its own. */
  size?: keyof typeof SIZES;
  role?: 'status';
}

/** A quiet inline note with an info icon, for explaining a state next to the control it affects. */
export const InfoNotice: FC<InfoNoticeProps> = ({children, size = 'sm', role}) => {
  const {icon, iconBox, padding} = SIZES[size];

  return (
    <div
      data-slot="info-notice"
      role={role}
      className={cn(
        'flex items-start gap-2 rounded-lg border border-border bg-background-secondary',
        padding
      )}
    >
      <span data-slot="icon" className={cn('flex shrink-0 items-center text-fg', iconBox)}>
        <Icon name="sollapay:info" width={icon} height={icon} aria-hidden="true" />
      </span>
      <Typography size={size} color="secondary" className="whitespace-normal">
        {children}
      </Typography>
    </div>
  );
};
